/* Recommendations: pages pick from one library (Footer › Recommendations library).
   A visitor won't see the same quote twice in one visit; once everyone has been shown,
   the longest-ago quote comes back first. Pinned names always show, in order. */
(function () {
  'use strict';
  if (window.__tpRecs) return; window.__tpRecs = true;
  var KEY = 'tp-recs-seen';
  var esc = function (s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var norm = function (s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); };
  var list = function (s) { return String(s || '').split(/[\n,]+/).map(norm).filter(Boolean); };
  function readSeen() { try { return JSON.parse(sessionStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; } }
  function writeSeen(a) { try { sessionStorage.setItem(KEY, JSON.stringify(a.slice(-60))); } catch (e) {} }
  function markSeen(names) { var s = readSeen().filter(function (n) { return names.indexOf(n) === -1; }); writeSeen(s.concat(names)); }

  function run() {
    var poolEl = document.querySelector('[data-recs-pool]'), pool = [];
    try { pool = JSON.parse(poolEl ? poolEl.textContent : '[]'); } catch (e) { pool = []; }
    pool = pool.filter(function (r) { return r && r.quote && r.name; });
    pool.forEach(function (r) { r.key = norm(r.name); r.tagList = list(r.tags); });

    // Quotes already on this page outside the library (e.g. the homepage) count as seen.
    var onPage = [].map.call(document.querySelectorAll('[data-rec-name]'), function (el) { return norm(el.getAttribute('data-rec-name')); });
    if (onPage.length) markSeen(onPage);

    document.querySelectorAll('[data-recs]').forEach(function (sec) {
      var mode = sec.getAttribute('data-mode') || 'pick';
      var count = Math.max(1, parseInt(sec.getAttribute('data-count'), 10) || 2);
      var tags = list(sec.getAttribute('data-tags'));
      var pins = list(sec.getAttribute('data-pin'));
      var feature = sec.getAttribute('data-feature') === 'true';
      var seen = readSeen();
      var byKey = {}; pool.forEach(function (r) { byKey[r.key] = r; });
      var pinned = pins.map(function (k) { return byKey[k]; }).filter(Boolean);
      var chosen;
      if (mode === 'all') {
        chosen = pinned.concat(pool.filter(function (r) { return pinned.indexOf(r) === -1; }));
      } else {
        chosen = pinned.slice(0, count);
        var rest = pool.filter(function (r) { return chosen.indexOf(r) === -1; });
        var rank = function (r) {
          var si = seen.indexOf(r.key), unseen = si === -1;
          var tagHit = !tags.length || r.tagList.some(function (t) { return tags.indexOf(t) > -1; });
          // unseen + matching tags first; featured breaks ties; then a little shuffle; seen ones by how long ago.
          return [unseen ? 0 : 1, tagHit ? 0 : 1, unseen ? (r.featured ? 0 : 1) : si, Math.random()];
        };
        var ranked = rest.map(function (r) { return { r: r, k: rank(r) }; }).sort(function (a, b) {
          for (var i = 0; i < 4; i++) if (a.k[i] !== b.k[i]) return a.k[i] - b.k[i];
          return 0;
        });
        while (chosen.length < count && ranked.length) chosen.push(ranked.shift().r);
        markSeen(chosen.map(function (r) { return r.key; }));
      }
      if (!chosen.length) return;
      sec.querySelector('[data-recs-list]').innerHTML = chosen.map(function (r, i) {
        return '<figure class="tp-rec' + (feature && i === 0 ? ' tp-rec--lead' : '') + '"><blockquote>' + esc(r.quote) + '</blockquote><figcaption><strong>' + esc(r.name) + '</strong>' +
          (r.role ? '<span>' + esc(r.role) + '</span>' : '') + (r.relation ? '<span class="tp-rec__rel">' + esc(r.relation) + '</span>' : '') + '</figcaption></figure>';
      }).join('');
      sec.hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
